import { on } from '@ngrx/store';
import {
  deleteOrganisation,
  loadOrganisations,
  setCurrentOrganisationID,
  setIsSuperAdmin,
  setOrganisation,
  setOrganisationColorPalette,
  setOrganisationFontFamily,
  setOrganisations,
  setOrgIsLoaded,
  setUserRoleInOrganisation,
} from './organisation.actions';
import { Organisation } from './organisation.interface';
import { loadHome } from '../home/home.actions';
import { createImmerReducer } from 'ngrx-immer/store';
import { set } from 'lodash';

export interface OrganisationState {
  listLoading: boolean;
  allOrganisations: Record<string, Organisation>;
  currentOrganisationID?: string;
  isSuperAdmin?: boolean;
  isOrganisationLoaded?: boolean;
}

export const initialState: OrganisationState = {
  listLoading: false,
  allOrganisations: {},
};

export const organisationReducer = createImmerReducer(
  initialState,
  on(loadOrganisations, state => ({ ...state, listLoading: true })),
  on(loadHome, state => ({ ...state, listLoading: true })),
  on(setCurrentOrganisationID, (state, { ID }) => {
    return {
      ...state,
      currentOrganisationID: ID,
    };
  }),
  on(setOrganisationColorPalette, (state, { colorPalette }) => {
    state.allOrganisations[state.currentOrganisationID].colorPalette =
      colorPalette;
    return state;
  }),
  on(setOrganisationFontFamily, (state, { fontFamily }) => {
    state.allOrganisations[state.currentOrganisationID].fontFamily = fontFamily;
    return state;
  }),
  on(setOrganisation, (state, { organisation }) => ({
    ...state,
    allOrganisations: {
      ...state.allOrganisations,
      [organisation.id]: organisation,
    },
    isOrganisationLoaded: true,
    listLoading: false,
  })),
  on(setUserRoleInOrganisation, (state, { organisationId, userId, role }) => {
    set(state.allOrganisations, [organisationId, 'roles', userId], role);
    return state;
  }),
  on(setIsSuperAdmin, (state, { value }) => {
    state.isSuperAdmin = value;
    return state;
  }),
  on(deleteOrganisation, (state, { organisationId }) => {
    delete state.allOrganisations[organisationId];
    return state;
  }),
  on(setOrganisations, (state, { organisations }) => ({
    ...state,
    allOrganisations: organisations.reduce(
      (existing, organisation) => ({
        ...existing,
        [organisation.id]: organisation,
      }),
      { ...state.allOrganisations },
    ),
    listLoading: false,
  })),
  on(setOrgIsLoaded, (state, { value }) => {
    state.isOrganisationLoaded = value;
    return state;
  }),
);
